import { del, get, put } from "common/request"

export const notificationsRequest = {
  count: () => get("/api/notifications/count"),
  list: () => get("/api/notifications"),
  markAllAsRead: () => del(`/api/notifications`),
  markAsRead: id => put(`/api/notifications/${id}`),
}
